module.exports = __webpack_public_path__ + "img/map-2-f@2x.0a89eb39.png";